import { render, staticRenderFns } from "./order-box.vue?vue&type=template&id=e218d54e&"
import script from "./order-box.vue?vue&type=script&lang=js&"
export * from "./order-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports